import { DpdExportRepeaterSettingsField } from './dpd-export-repeater-settings-field';

window.DpdExportSettingsRepeater = class extends (
	DpdExportRepeaterSettingsField
) {
	constructor(el) {
		super(el);
	}

	renderRow(inputData = []) {
		return `
			<li class="repeatable-field__row">
				<div class="repeatable-field__row-wrap">
					<input
							class="repeatable-field__input repeatable-field__input--radio form-field"
							type="radio"
							data-ref="input-default"
							name="${this.props.inputName}_default[]"
							value="${'value' in inputData ? inputData.value : ''}"
							${'default' in inputData && inputData.default ? 'checked' : ''}
					/>

					<input
							class="repeatable-field__input form-field"
							data-ref="input-nice"
							type="text"
							name="${this.props.inputName}_nice_value[]"
							placeholder="${this.props.titlePlaceholder}"
							value="${'nice_value' in inputData ? inputData.nice_value : ''}"
					/>

					<input
							class="repeatable-field__input form-field"
							data-ref="input"
							type="text"
							name="${this.props.inputName}_value[]"
							value="${'value' in inputData ? inputData.value : ''}"
							placeholder="${this.props.valuePlaceholder}"
							onchange="this.parentNode.querySelector('[data-ref=input-default]').value = this.value"
					/>

					<button
							class="repeatable-field__remove-button button"
							data-ref="removeButton"
							type="button"
					>
						${this.props.removeLabel ?? 'Remove'}
					</button>
				</div>
			</li>
	`;
	}

	maybeCheckOneOptionAsDefault() {
		const checkedInputs = this.el.querySelectorAll('[checked]');

		if (checkedInputs.length) {
			return;
		}

		// Check first element
		this.el.querySelector('[type="radio"]').checked = true;
	}

	removeRow(row) {
		if (this.refs.rowList.children.length <= 1) return;

		row.remove();
		this.el.focus();

		this.maybeCheckOneOptionAsDefault();

		if (this.refs.rowList.children.length < this.props.maxRows) {
			this.refs.addButton.style.display = '';
		}
	}

	init() {
		if (this.inputsData.length) {
			this.inputsData.forEach((inputData) => {
				this.addRow(inputData);
			});
		} else {
			this.addRow();
		}

		this.refs.addButton.onclick = (e) => {
			e.preventDefault();
			this.addRow();
		};

		this.maybeCheckOneOptionAsDefault();
	}
};

document.querySelectorAll('[data-component="field-repeater"]').forEach((el) => {
	const fieldRepeater = new window.DpdExportSettingsRepeater(el);
	fieldRepeater.init();
});
